<script>
import AmsuScholarshipCard from "../AmsuScholarshipCard.vue";
import TheMeetingBasicInformationDialog from "../../Dialogs/Meeting/Information/TheMeetingBasicInformationDialog.vue";
export default {
  name: "TheMeetingScholarshipHeaderCard",

  components: {
    AmsuScholarshipCard,
    TheMeetingBasicInformationDialog,
  },

  data() {
    return {
      headerText: "Заседания стипендиальной комиссии ПГАС",
      showBasicInformationDialog: false,
    };
  }
}
</script>

<template>


<AmsuScholarshipCard>
  <v-card-title class="d-flex align-center justify-center">
    {{headerText}}
    <v-spacer/>

    <v-btn
      class="rounded-xl white--text"
      color="teal darken-3"
      small
      @click="$emit('backDashboard')"
    >
      <v-icon small left>
        fa-reply
      </v-icon>
      Назад
    </v-btn>

    <v-btn
      icon
      @click="showBasicInformationDialog = true"
    >
      <v-icon>
        fa-question-circle
      </v-icon>
    </v-btn>
  </v-card-title>

  <the-meeting-basic-information-dialog
    :visible="showBasicInformationDialog"
    @close="showBasicInformationDialog = false"
  />
</AmsuScholarshipCard>
</template>

<style scoped>

</style>